export const LESEN_TASKS = [
  {
    "id": "lesen-teil1",
    "teil": 1,
    "title": "Teil 1 — Moderne Lebensformen",
    "arbeitzeit": "Teil 1 vorgeschlagene Arbeitszeit: 18 Minuten",
    "instruction": "Sie lesen in einem Forum, wie Menschen über Minimalismus im täglichen Leben denken. Auf welche der vier Personen treffen die einzelnen Aussagen zu? Die Personen können mehrmals gewählt werden.",
    "timeMinutes": 18,
    "texts": [
      {
        "id": "a",
        "label": "a",
        "author": "Erik",
        "title": "Moderne Lebensformen",
        "body": "In der heutigen Gesellschaft wird leider nur noch konsumiert. Es zählen Besitz und Leistung und das im Überfluss; das ist den Menschen wichtig. Ich sehe das anders, denn ich habe nur Sachen, die ich wirklich brauche. Ein Autokauf käme mir zum Beispiel nicht in den Sinn, ich bevorzuge das Rad oder gehe zu Fuß. Eine größere Wohnung? Warum? – Meine Einzimmerwohnung ist fast leer: Bett, Tisch, zwei Stühle, Garderobe. Einen Kühlschrank brauche ich nicht. Auch als Veganer kann man genussvoll essen. Erdbeeren und Salat pflanze ich auf dem Balkon an. Wenn ich reise, dann mit Rucksack und Zelt, ohne Kamera und Schnickschnack. Bei Freunden daheim mit tollen Fotos angeben gibt mir nichts. Das hat nichts mit Geiz zu tun – das einfache und entspannte Leben ist, was ich will."
      },
      {
        "id": "b",
        "label": "b",
        "author": "Katharina",
        "title": "Moderne Lebensformen",
        "body": "Die gesamte Debatte über die richtige Lebensweise nervt mich: Warum auf etwas verzichten? Dinge können die schönste Nebensache der Welt sein! Am Abend kehre ich gern in meine Wohnung heim und am Wochenende lade ich lieber Freunde ein, um ihnen Bilder von meinem letzten Urlaub zu zeigen, als mich beim Sport abzumühen. Viel brauche ich nicht, um mich in den Großstädten der Welt wohlzufühlen: ein bisschen Luxus im Hotel, interessante Ausstellungen und schick essen gehen. Viel nehme ich schon deswegen nicht mit, damit im Koffer genug Platz für die Einkäufe ist. Zu einem guten Steak sage ich nie nein. Gesund kann, muss Essen aber nicht sein – man lebt schließlich nur einmal. Mein Auto, ein Cabriolet, nutze ich jeden Tag beruflich, im Sommer am liebsten mit dem Dach offen. Bescheidenheit ist doch nur etwas für die Leute, die sich nichts leisten können."
      },
      {
        "id": "c",
        "label": "c",
        "author": "Franzi",
        "title": "Moderne Lebensformen",
        "body": "Für mich ist es wichtig, sowohl gut zu mir als auch zu meiner Umwelt zu sein. Im Alltag versuche ich auf Fleisch zu verzichten und baue Kräuter am Fenster meines kleinen, aber feinen Appartements an. Ich genieße es, am Wochenende mit Freunden gut essen zu gehen, und wenn es mal nichts Vegetarisches gibt, esse ich ab und zu auch Fleisch. Zur Arbeit nehme ich am liebsten das Rad – das hält mich fit und ist nebenbei auch noch umweltfreundlich; bei Schnee und Regen sind dann aber doch die Öffentlichen angenehmer. Vielleicht mache ich irgendwann mal Carsharing, also Autos am Straßenrand mieten. Mit Geld hat das alles aber nichts zu tun. Es besteht für mich ein großer Unterschied zwischen Urlaub und Reisen: Im Urlaub gönne ich mir gerne etwas: Ein Sterne-Hotel oder einen Einkaufstrip. Auf Reisen jedoch will ich Neues entdecken. Da erkunde ich Länder am liebsten auf Wanderungen."
      },
      {
        "id": "d",
        "label": "d",
        "author": "Nils",
        "title": "Moderne Lebensformen",
        "body": "Ich halte das für eine ziemlich deutsche Debatte! In keinem anderen Land wird so viel über das Thema 'Richtig leben' diskutiert. Geld ist nicht alles, aber kann nicht schaden; z. B. für Bio Produkte: Ich selbst kaufe Fleisch und Wurst auf dem Bauernhof ein, nicht nur der Natur und der Gesundheit zuliebe, es schmeckt einfach besser, und viel Fleisch esse ich sowieso nicht. Der Versuch, einfach und natürlich zu leben, ist bei der Ernährung leider nicht immer kostengünstig. Das Thema 'Auto' sehe ich eher nicht ideologisch: Für mich ist es in erster Linie ein Fortbewegungsmittel, das manchmal notwendig ist, manchmal auch einfach nur bequem. Wegen des Verkehrs benutze ich oft die Öffentlichen oder das Rad. Ich habe eine Zwei-Zimmer-Wohnung in der Innenstadt und zwar in Flussnähe, der Blick aufs Wasser ist mir wichtig. Für meine Reisen habe ich ein Wohnmobil mit allem Luxus. Da ist man völlig frei und hat doch immer alles Nötige dabei!"
      }
    ],
    "questions": [
      {
        "id": "q1",
        "type": "person_match",
        "statement": "Wer sieht im Auto einen Gebrauchsgegenstand?",
        "correct": "d"
      },
      {
        "id": "q2",
        "type": "person_match",
        "statement": "Wer empfindet Besitz als unwichtig?",
        "correct": "a"
      },
      {
        "id": "q3",
        "type": "person_match",
        "statement": "Wer verzichtet auf Fleisch?",
        "correct": "c"
      },
      {
        "id": "q4",
        "type": "person_match",
        "statement": "Für wen spielt die Lage der Wohnung eine große Rolle?",
        "correct": "d"
      },
      {
        "id": "q5",
        "type": "person_match",
        "statement": "Für wen ist der Naturschutz bei Entscheidungen wichtig?",
        "correct": "a"
      },
      {
        "id": "q6",
        "type": "person_match",
        "statement": "Wer denkt, einfach lebende Personen hätten zu wenig Geld?",
        "correct": "b"
      },
      {
        "id": "q7",
        "type": "person_match",
        "statement": "Wer nimmt auf Reisen nichts Überflüssiges mit?",
        "correct": "a"
      },
      {
        "id": "q8",
        "type": "person_match",
        "statement": "Für wen zählt beim Essen allein, etwas zu genießen?",
        "correct": "b"
      },
      {
        "id": "q9",
        "type": "person_match",
        "statement": "Wer mag sowohl Luxus als auch das einfache Leben?",
        "correct": "c"
      }
    ]
  },
  {
    "id": "lesen-teil2",
    "teil": 2,
    "title": "Teil 2 — Reisefieber",
    "arbeitzeit": "Teil 2 vorgeschlagene Arbeitszeit: 15 Minuten",
    "instruction": "Sie lesen in einer Zeitschrift einen Artikel über die Geschichte des Reisens. Welche Sätze passen in die Lücken? Zwei Sätze passen nicht.",
    "timeMinutes": 15,
    "article": {
      "title": "Reisefieber",
      "subtitle": "Heute verreist fast jeder, früher aber kaum jemand.",
      "paragraphs": [
        "Über eine Milliarde Menschen reisen jährlich in ein anderes Land. Ob von Deutschland nach Italien, von Kanada nach Mexiko oder von Japan nach Australien. Noch nie waren so viele Touristen unterwegs. Kaum ein Wirtschaftszweig wächst so schnell und kontinuierlich wie der Tourismus. {{GAP:10}}",
        "Schon in der Antike gingen Menschen an andere Orte. Oft zu Fuß oder mit dem Pferd. Das dauerte jedoch lange und war sehr mühsam. Nur wenige konnten es sich leisten, in einer Kutsche zu reisen. Besonders schnell war die Kutsche allerdings auch nicht. {{GAP:11}} Erst als die Eisenbahn und das Dampfschiff erfunden wurden, änderte sich das.",
        "Die Reisen, wie wir sie heute kennen, verdanken wir vor allem dem Briten Thomas Cook. Er organisierte 1841 eine Zugfahrt mit Blasmusik, Tee und belegten Broten in eine 20 km entfernte Kleinstadt. {{GAP:12}} Damit erfand der Brite die erste Pauschalreise der Welt – ein großer Erfolg.",
        "Die meisten solcher Reisen blieben jedoch lange ein Luxus, den sich die meisten Menschen nicht leisten konnten. An sechs Tagen der Woche und zehn Stunden am Tag zu arbeiten, war um 1900 normal. {{GAP:13}} Dies änderte sich im Laufe des 20. Jahrhunderts, als die Arbeiter mehr Freizeit bekamen, die Löhne stiegen und die Reisekosten sanken. Seitdem steigt die Anzahl der Touristen stetig.",
        "Die derzeit beliebtesten Reiseziele weltweit sind Frankreich, die USA und Spanien. Aber auch Deutschland zieht immer mehr Reisende an. Insbesondere die 15- bis 24-jährigen Europäer kommen gerne nach Deutschland. Am liebsten fahren sie in die großen Städte wie Berlin oder München. {{GAP:14}} Ein Grund dafür, dass Städtereisen insgesamt immer beliebter werden.",
        "Die Touristen haben das Aussehen vieler Orte verändert. {{GAP:15}} So entstand das typische Bild, das man heute an vielen Orten sieht, die touristisch geprägt sind: blaues Meer, Sandstrand und Hochhäuser. Auch die Städte verändern sich. Cafés und Restaurants werden immer teurer. {{GAP:16}} Vor allem Anwohner ärgern sich darüber. Aber auch Touristen suchen immer häufiger nach Orten, die weniger besucht werden."
      ]
    },
    "sentenceBank": [
      {
        "id": "a",
        "text": "Denn immer mehr Menschen können es sich leisten zu verreisen."
      },
      {
        "id": "b",
        "text": "Dort gibt es neben den vielen Bars und Clubs auch viele gute Kulturangebote."
      },
      {
        "id": "c",
        "text": "Dennoch fahren immer mehr Touristen aufs Land."
      },
      {
        "id": "d",
        "text": "Noch Ende des 18. Jahrhunderts war man von München nach Frankfurt 74 Stunden unterwegs."
      },
      {
        "id": "e",
        "text": "Alle Leistungen gab es zu einem geringen Gesamtpreis."
      },
      {
        "id": "f",
        "text": "Hotels und Häuserblocks mit Urlaubswohnungen prägen heute vielerorts das Bild."
      },
      {
        "id": "g",
        "text": "Es gab nur drei Tage Urlaub im Jahr."
      },
      {
        "id": "h",
        "text": "Diese Veränderungen gefallen natürlich nicht jedem."
      }
    ],
    "questions": [
      {
        "id": "q10",
        "type": "gap_fill",
        "gap": 10,
        "correct": "a"
      },
      {
        "id": "q11",
        "type": "gap_fill",
        "gap": 11,
        "correct": "d"
      },
      {
        "id": "q12",
        "type": "gap_fill",
        "gap": 12,
        "correct": "e"
      },
      {
        "id": "q13",
        "type": "gap_fill",
        "gap": 13,
        "correct": "g"
      },
      {
        "id": "q14",
        "type": "gap_fill",
        "gap": 14,
        "correct": "b"
      },
      {
        "id": "q15",
        "type": "gap_fill",
        "gap": 15,
        "correct": "f"
      },
      {
        "id": "q16",
        "type": "gap_fill",
        "gap": 16,
        "correct": "h"
      }
    ]
  },
  {
    "id": "lesen-teil3",
    "teil": 3,
    "title": "Teil 3 — Doktor Google",
    "instruction": "Sie lesen in einer Zeitung einen Artikel über das Verhalten von Kranken in Zeiten des Internets. Wählen Sie bei jeder Aufgabe die richtige Lösung.",
    "timeMinutes": 12,
    "texts": [
      {
        "id": "artikel",
        "title": "Doktor Google",
        "body": "Das Wartezimmer beim Arzt ist voll mit Menschen, Bakterien und verbrauchter Luft. Bevor sich ein Kranker zusätzliche Viren ins Gesicht husten lässt, bleibt er manchmal lieber zu Hause und sucht Rat beim Doktor im Netz. Der ist zwar meist virtuell, antwortet nur in wenigen Portalen auf konkrete Fragen, und Garantie übernimmt er sowieso keine.\n\nVon den Deutschen suchen 38 Prozent bei Gesundheitsfragen Rat im Netz und klicken Gesundheitsportale an, fand man kürzlich heraus. Innerhalb der Europäischen Union war das Interesse nur in Schweden, Norwegen und in Finnland noch größer. Laut einer Studie gehört zu den meistgesuchten Krankheiten Diabetes, woran so viele Europäer leiden. Ebenfalls oft gesucht: Leiden, über die viele nicht gerne sprechen, auch nicht mit dem Arzt.\n\nJe mehr das Krankheiten-Googeln zum Volkssport wird, desto stärker stellt sich für Politiker und Mediziner die Frage nach der Qualität des Angebots. Kann sein, dass dort Hilfe wartet. Kann aber auch sein, dass die Beschwerden sich nach der Lektüre schlimmer anfühlen als vorher.\n\nDenn die Qualität ist in vielen Fällen richtig schlecht: Es gibt häufig lückenhafte Informationen und Widersprüche. Manchmal dienen die Texte und Bilder vor allem dazu, für ein Medikament oder eine Heilmethode zu werben. Wer sich stundenlang durch die Ergebnislisten klickt, landet auf Seiten von Krankenkassen, Vereinen, Pharmaunternehmen, Verlagen, Medizinern, Hobbyratgebern.\n\nDie organisierte Ärzteschaft ist keineswegs grundsätzlich dagegen, wenn sich Patienten im Netz schlau machen. 'Die Frage ist nur, wann sie es tun und wo sie suchen', sagt Claudia Becker vom Institut 'Medizinisches Zentrum für therapeutische Qualität'. Dort hält man es für falsch, Krankheitssymptome, die man bei sich entdeckt hat, per Suchmaschine selbst zu diagnostizieren. 'Wenn Patienten richtige und gute Informationen haben, vereinfacht das vieles.' Ziel ist dabei nicht das Verständnis fachlicher Details. 'Aber Patienten können Ärzte später informiert fragen – und genau darum geht es.'\n\nWer Informationen unkritisch aufnimmt, für den bringt das Netz Gefahren statt Orientierung mit sich: Nicht wenige Versprechen auf Heilung sind Betrug. Auch Internetseiten und -foren, die Patienten über Selbsthilfe informieren, sollten mit Vorsicht gelesen werden. 'Es ist natürlich vorteilhaft, wenn Ratsuchende anonym von den Erfahrungen ebenfalls Betroffener profitieren können. Andererseits wissen sie nie, mit wem sie sich da gerade über hochsensible Dinge unterhalten.'\n\nEine gewisse Gefahr bestehe vor allem dann, wenn in Foren persönliche Daten wie Mail-Adressen, Telefonnummern oder Krankengeschichten abgefragt würden: 'Immer wieder kommt es in Patientenforen vor, dass das Gespräch mit anderen Kranken insgeheim von Dritten benutzt wird: Oft wird man danach pausenlos mit unerwünschter Werbung der Gesundheits-Industrie bombardiert.'"
      }
    ],
    "questions": [
      {
        "id": "q17",
        "question": "Das Interesse richtet sich auf Krankheiten, …",
        "options": [
          "die auch Ärzte überfordern.",
          "die besonders schmerzhaft sind.",
          "für die sich die Betroffenen schämen."
        ],
        "correct": 2
      },
      {
        "id": "q18",
        "question": "Viele Mediziner und Politiker zweifeln daran, dass …",
        "options": [
          "das Internet brauchbare Hilfe liefert.",
          "die berichteten Beschwerden echt sind.",
          "sich die Gesundheit der Kranken verbessert."
        ],
        "correct": 0
      },
      {
        "id": "q19",
        "question": "Was ist am Internet-Angebot oft so schlecht?",
        "options": [
          "Das Angebot ist zu groß.",
          "Es gibt falsche Informationen.",
          "Viele Informationen sind unvollständig."
        ],
        "correct": 2
      },
      {
        "id": "q20",
        "question": "Claudia Becker findet, Patienten sollten sich im Netz …",
        "options": [
          "auf das Arztgespräch vorbereiten.",
          "detailliertes Fachwissen anlesen.",
          "nach einem Arztgespräch informieren."
        ],
        "correct": 0
      },
      {
        "id": "q21",
        "question": "Claudia Becker warnt Patienten vor …",
        "options": [
          "gefährlichen Versprechen im Netz.",
          "Anleitungen zur Selbsttherapie.",
          "Kontakt mit anonymen Ratsuchenden."
        ],
        "correct": 0
      },
      {
        "id": "q22",
        "question": "Ratsuchende sollten vorsichtig sein, in Foren …",
        "options": [
          "ihre Krankheit zu beschreiben.",
          "Informationen über sich weiterzugeben.",
          "auf Werbung der Gesundheitsindustrie zu reagieren."
        ],
        "correct": 1
      }
    ]
  },
  {
    "id": "lesen-teil4",
    "teil": 4,
    "title": "Teil 4 — Digitale Nomaden",
    "instruction": "Sie lesen in einer Zeitschrift Meinungsäußerungen zu dem Lebensmodell „digitale Nomaden“. Welche Äußerung passt zu welcher Überschrift? Eine Äußerung passt nicht. Die Äußerung a ist das Beispiel und kann nicht noch einmal verwendet werden.",
    "timeMinutes": 12,
    "headlines": [
      {
        "id": "h22",
        "text": "Sich zu Hause zu fühlen, ist wichtig"
      },
      {
        "id": "h23",
        "text": "Moderne Arbeitsgeräte ermöglichen neue Arbeitsformen und Lebensweisen"
      },
      {
        "id": "h24",
        "text": "Arbeiten ohne einen Vorgesetzten bringt Herausforderungen"
      },
      {
        "id": "h25",
        "text": "Leben als digitaler Nomade eignet sich besonders für Singles"
      },
      {
        "id": "h26",
        "text": "Wichtig ist der Austausch mit Kollegen auch außerhalb der Arbeit"
      },
      {
        "id": "h27",
        "text": "Qualitätssteigerung durch den Austausch unter Kollegen"
      }
    ],
    "texts": [
      {
        "id": "a",
        "label": "a",
        "author": "Amelie, Bonn",
        "body": "Es hört sich im ersten Moment vielleicht etwas überraschend an – aber gerade für berufstätige Eltern hat das digitale Nomadentum Pluspunkte: Man kann seinen Kindern die Welt zeigen und sich tagsüber die Zeit für sie nehmen, die sie brauchen; gearbeitet wird dann eben nachts."
      },
      {
        "id": "b",
        "label": "b",
        "author": "Eva, Berlin",
        "body": "Die Gefahr, dass die eigene Leistung absinkt, ist einfach zu groß: Jede Arbeit braucht Struktur und das Gespräch mit Experten, um herauszufinden, ob man richtig liegt. Wenn jeder immer nur allein vor sich hin arbeitet, fehlt der Vergleich."
      },
      {
        "id": "c",
        "label": "c",
        "author": "Inga, Hannover",
        "body": "Auch wenn es unter den Jüngeren heutzutage Mode ist, sich als digitale Nomaden zu verstehen – wieso möchte keiner mehr fest an einem Ort verankert sein? Woher weiß man denn sonst, wohin man gehört?"
      },
      {
        "id": "d",
        "label": "d",
        "author": "Steven, Greifswald",
        "body": "Kaum jemand kann und will ständig allein am Computer vor sich hinarbeiten. Das Arbeiten in flexiblen Büros wäre eine Möglichkeit, einen ständigen Austausch möglich zu machen, fachlich wie menschlich. Aber man würde dabei hoffentlich nicht die Freiheit verlieren, weiterzuziehen, wenn und wann man will."
      },
      {
        "id": "e",
        "label": "e",
        "author": "Jan, Chemnitz",
        "body": "Diese Arbeitsform funktioniert nur ohne Familie und Verantwortung. Wer hat schon einen Partner, der ständig umziehen kann und will, weil er selbst digitaler Nomade ist? Und sobald eine gute Schulbildung für den Nachwuchs gesichert werden muss, hat dieses Arbeitsmodell mehr Nachteile als Vorteile."
      },
      {
        "id": "f",
        "label": "f",
        "author": "Sarah, München",
        "body": "Es darf nicht vergessen werden, dass auch das Berufsleben aus mehr als nur Arbeit besteht: Mit wem wird die Mittagspause verbracht? Wer hat schon Lust, immer allein zu sein? Wer hat schon die Kraft, sich alle paar Wochen einen neuen Freundeskreis aufzubauen?"
      },
      {
        "id": "g",
        "label": "g",
        "author": "Janice, Magdeburg",
        "body": "Zeit- und raumflexibel zu arbeiten, wo und wann auch immer man will – vom Laptop, Smartphone oder Tablet aus –, nennt man digitales Nomadentum. Das mag für manche zwar etwas traurig klingen, nach Verlust der Heimat, aber es ist das einzige dem 21. Jahrhundert angemessene Arbeitsmodell."
      },
      {
        "id": "h",
        "label": "h",
        "author": "Katharina, Stuttgart",
        "body": "Bei allen Vorzügen besteht doch die ständige Angst, zu viel zu reisen und zu wenig zu schaffen. Es ist letztlich alles eine Frage des Charakters: Um sein eigener Chef zu sein, ist auf jeden Fall ein hohes Maß an Selbstorganisation und Selbstdisziplin notwendig."
      }
    ],
    "questions": [
      {
        "id": "q23",
        "type": "headline_match",
        "headlineId": "h22",
        "statement": "Sich zu Hause zu fühlen, ist wichtig",
        "correct": "c"
      },
      {
        "id": "q24",
        "type": "headline_match",
        "headlineId": "h23",
        "statement": "Moderne Arbeitsgeräte ermöglichen neue Arbeitsformen und Lebensweisen",
        "correct": "g"
      },
      {
        "id": "q25",
        "type": "headline_match",
        "headlineId": "h24",
        "statement": "Arbeiten ohne einen Vorgesetzten bringt Herausforderungen",
        "correct": "h"
      },
      {
        "id": "q26",
        "type": "headline_match",
        "headlineId": "h25",
        "statement": "Leben als digitaler Nomade eignet sich besonders für Singles",
        "correct": "e"
      },
      {
        "id": "q27",
        "type": "headline_match",
        "headlineId": "h26",
        "statement": "Wichtig ist der Austausch mit Kollegen auch außerhalb der Arbeit",
        "correct": "f"
      },
      {
        "id": "q28",
        "type": "headline_match",
        "headlineId": "h27",
        "statement": "Qualitätssteigerung durch den Austausch unter Kollegen",
        "correct": "b"
      }
    ]
  },
  {
    "id": "lesen-teil5",
    "teil": 5,
    "title": "Teil 5 — Studienordnung",
    "arbeitzeit": "Teil 5 vorgeschlagene Arbeitszeit: 6 Minuten",
    "instruction": "Sie möchten an der Universität Bremen studieren und lesen die Studienordnung. Welche der Überschriften aus dem Inhaltsverzeichnis passen zu den Paragrafen? Vier Überschriften werden nicht gebraucht.",
    "timeMinutes": 6,
    "headings": [
      {
        "id": "A",
        "label": "A",
        "text": "Abschluss des Bachelorstudiums"
      },
      {
        "id": "B",
        "label": "B",
        "text": "Aufbau und Inhalte des Studiums"
      },
      {
        "id": "C",
        "label": "C",
        "text": "Studienbeginn"
      },
      {
        "id": "D",
        "label": "D",
        "text": "Studiendauer und Studienvolumen"
      },
      {
        "id": "E",
        "label": "E",
        "text": "Vermittlungsformen"
      },
      {
        "id": "F",
        "label": "F",
        "text": "Zugangsvoraussetzungen"
      },
      {
        "id": "G",
        "label": "G",
        "text": "Studienziele"
      },
      {
        "id": "H",
        "label": "H",
        "text": "Auslandsaufenthalt"
      }
    ],
    "texts": [
      {
        "id": "p0",
        "label": "§ 0",
        "title": "Studienordnung — Theaterwissenschaft",
        "body": "Das Studium kann nur zum Wintersemester aufgenommen werden."
      },
      {
        "id": "p28",
        "label": "§ 28",
        "title": "Studienordnung — Theaterwissenschaft",
        "body": "Die allgemeine Qualifikation für das Studium wird durch ein Zeugnis der Hochschulzugangsberechtigung gemäß § 17 BremHG (insbesondere allgemeine Hochschulreife, fachgebundene Hochschulreife, Fachhochschulreife) oder ein durch Rechtsvorschrift oder von der zuständigen staatlichen Stelle als gleichwertig anerkanntes Zeugnis nachgewiesen.\n\nFachspezifisch: der Nachweis von Kenntnissen in Englisch (Gemeinsamer europäischer Referenzrahmen, Stufe B2) und einer weiteren modernen Fremdsprache (Stufe B1) oder der Nachweis von Kenntnissen in Englisch (Stufe B2) und Lateinkenntnissen jeweils vor Studienbeginn."
      },
      {
        "id": "p29",
        "label": "§ 29",
        "title": "Studienordnung — Theaterwissenschaft",
        "body": "(1) Die Regelstudienzeit umfasst sechs Semester. Der Gesamtumfang des studentischen Arbeitsaufwandes für das Bachelorstudium Theaterwissenschaft beträgt 180 Leistungspunkte.\n(2) Das Studium kann auch als Teilzeitstudium betrieben werden. Im Falle eines Teilzeitstudiums verringert sich der studentische Arbeitsaufwand pro Jahr entsprechend dem Anteil des Teilzeitstudiums. Die Regelstudienzeit verlängert sich entsprechend."
      },
      {
        "id": "p30",
        "label": "§ 30",
        "title": "Studienordnung — Theaterwissenschaft",
        "body": "– Vorlesungen (V) – Übungen (Ü) – Tutorien (Tut) – Seminare (S) – Praktika (P)\n\nDie Modulverantwortlichen können festlegen, dass eine Lernplattform begleitend zum Präsenzstudium für die Vermittlung von Lehrinhalten eingesetzt wird."
      }
    ],
    "questions": [
      {
        "id": "q29",
        "type": "heading_match",
        "paragraphId": "p28",
        "statement": "§ 28",
        "correct": "F"
      },
      {
        "id": "q30",
        "type": "heading_match",
        "paragraphId": "p29",
        "statement": "§ 29",
        "correct": "D"
      },
      {
        "id": "q31",
        "type": "heading_match",
        "paragraphId": "p30",
        "statement": "§ 30",
        "correct": "E"
      }
    ]
  }
];
